import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import NearMeOutlinedIcon from "@mui/icons-material/NearMeOutlined";
import GestureOutlinedIcon from "@mui/icons-material/GestureOutlined";
import HorizontalRuleOutlinedIcon from "@mui/icons-material/HorizontalRuleOutlined";
import CallMadeOutlinedIcon from "@mui/icons-material/CallMadeOutlined";
import RadioButtonUncheckedOutlinedIcon from "@mui/icons-material/RadioButtonUncheckedOutlined";
import CropSquareOutlinedIcon from "@mui/icons-material/CropSquareOutlined";
import CropFreeOutlinedIcon from "@mui/icons-material/CropFreeOutlined";
import CropOutlinedIcon from "@mui/icons-material/CropOutlined";
import TitleOutlinedIcon from "@mui/icons-material/TitleOutlined";
import FormatAlignLeftOutlinedIcon from "@mui/icons-material/FormatAlignLeftOutlined";
import TextFieldsOutlinedIcon from "@mui/icons-material/TextFieldsOutlined";
import AutoFixOffOutlinedIcon from "@mui/icons-material/AutoFixOffOutlined";
import PanToolOutlinedIcon from "@mui/icons-material/PanToolOutlined";
import ZoomInOutlinedIcon from "@mui/icons-material/ZoomInOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import GridOnOutlinedIcon from "@mui/icons-material/GridOnOutlined";
import AlignHorizontalLeftOutlinedIcon from "@mui/icons-material/AlignHorizontalLeftOutlined";
import AlignHorizontalCenterOutlinedIcon from "@mui/icons-material/AlignHorizontalCenterOutlined";
import AlignHorizontalRightOutlinedIcon from "@mui/icons-material/AlignHorizontalRightOutlined";
import AlignVerticalTopOutlinedIcon from "@mui/icons-material/AlignVerticalTopOutlined";
import AlignVerticalCenterOutlinedIcon from "@mui/icons-material/AlignVerticalCenterOutlined";
import AlignVerticalBottomOutlinedIcon from "@mui/icons-material/AlignVerticalBottomOutlined";
import SwapHorizOutlinedIcon from "@mui/icons-material/SwapHorizOutlined";
import SwapVertOutlinedIcon from "@mui/icons-material/SwapVertOutlined";
import HexagonOutlinedIcon from "@mui/icons-material/HexagonOutlined";
import StarOutlineOutlinedIcon from "@mui/icons-material/StarOutlineOutlined";
import BrushOutlinedIcon from "@mui/icons-material/BrushOutlined";
import ContentCutOutlinedIcon from "@mui/icons-material/ContentCutOutlined";
import RotateRightOutlinedIcon from "@mui/icons-material/RotateRightOutlined";
import OpenWithOutlinedIcon from "@mui/icons-material/OpenWithOutlined";
import FlipOutlinedIcon from "@mui/icons-material/FlipOutlined";
import TransformOutlinedIcon from "@mui/icons-material/TransformOutlined";
import ColorizeOutlinedIcon from "@mui/icons-material/ColorizeOutlined";
import GradientOutlinedIcon from "@mui/icons-material/GradientOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import AutoFixHighOutlinedIcon from "@mui/icons-material/AutoFixHighOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import FilterCenterFocusOutlinedIcon from "@mui/icons-material/FilterCenterFocusOutlined";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import CallMergeOutlinedIcon from "@mui/icons-material/CallMergeOutlined";
import JoinFullOutlinedIcon from "@mui/icons-material/JoinFullOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import SquareFootOutlinedIcon from "@mui/icons-material/SquareFootOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import CallSplitOutlinedIcon from "@mui/icons-material/CallSplitOutlined";
import FlipToFrontOutlinedIcon from "@mui/icons-material/FlipToFrontOutlined";
import FlipToBackOutlinedIcon from "@mui/icons-material/FlipToBackOutlined";
import WorkspacesOutlinedIcon from "@mui/icons-material/WorkspacesOutlined";
import FilterNoneOutlinedIcon from "@mui/icons-material/FilterNoneOutlined";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import FormatColorFillOutlinedIcon from "@mui/icons-material/FormatColorFillOutlined";
import OpacityOutlinedIcon from "@mui/icons-material/OpacityOutlined";
import HighlightAltOutlinedIcon from "@mui/icons-material/HighlightAltOutlined";
import { VC_BASIC_TOOLBAR } from "./moodboardVcTools";

/** Estilo VectorCraft MediumDark + accent coral. */
const VC = {
  panel: "#181b22",
  panelBorder: "#2a2f3a",
  icon: "#c5cad3",
  iconDim: "#6b7280",
  hover: "rgba(255,255,255,0.08)",
  activeBg: "rgba(217,71,47,0.22)",
  accent: "#d9472f",
  flyout: "#13161c",
  text: "#e8eaed",
  textDim: "#9aa0a8",
};

const ICON_BY_ID = {
  selection: NearMeOutlinedIcon,
  directSelection: FilterCenterFocusOutlinedIcon,
  groupSelection: NearMeOutlinedIcon,
  groupMarks: WorkspacesOutlinedIcon,
  ungroupMarks: FilterNoneOutlinedIcon,
  lasso: TimelineOutlinedIcon,
  magicWand: AutoFixHighOutlinedIcon,
  rectangle: CropSquareOutlinedIcon,
  roundedRectangle: CropFreeOutlinedIcon,
  ellipse: RadioButtonUncheckedOutlinedIcon,
  polygon: HexagonOutlinedIcon,
  star: StarOutlineOutlinedIcon,
  lineSegment: HorizontalRuleOutlinedIcon,
  arc: TimelineOutlinedIcon,
  spiral: TimelineOutlinedIcon,
  rectangularGrid: DashboardOutlinedIcon,
  polarGrid: RadioButtonUncheckedOutlinedIcon,
  flare: AutoFixHighOutlinedIcon,
  arrow: CallMadeOutlinedIcon,
  blobBrush: BrushOutlinedIcon,
  pathEraser: AutoFixOffOutlinedIcon,
  anchorPoint: FilterCenterFocusOutlinedIcon,
  curvature: TimelineOutlinedIcon,
  lineCut: CallSplitOutlinedIcon,
  rectCut: CropSquareOutlinedIcon,
  mirrorCut: FlipOutlinedIcon,
  width: OpenWithOutlinedIcon,
  warp: TransformOutlinedIcon,
  puppetWarp: OpenWithOutlinedIcon,
  twirl: RotateRightOutlinedIcon,
  pucker: OpenWithOutlinedIcon,
  bloat: RadioButtonUncheckedOutlinedIcon,
  scallop: AutoFixHighOutlinedIcon,
  crystallize: HexagonOutlinedIcon,
  wrinkle: GestureOutlinedIcon,
  reshape: TransformOutlinedIcon,
  shaper: CategoryOutlinedIcon,
  shapeBuilder: JoinFullOutlinedIcon,
  makeClippingMask: CropOutlinedIcon,
  releaseClippingMask: CropFreeOutlinedIcon,
  rotateView: RotateRightOutlinedIcon,
  sendToPasteboard: DashboardOutlinedIcon,
  blend: CallMergeOutlinedIcon,
  envelopeWarp: TransformOutlinedIcon,
  envelopeMesh: GridOnOutlinedIcon,
  perspectiveGrid: GridOnOutlinedIcon,
  perspectiveSelect: NearMeOutlinedIcon,
  objectsOnPath: TimelineOutlinedIcon,
  symbolShifter: OpenWithOutlinedIcon,
  expandObjectsOnPath: CallSplitOutlinedIcon,
  symbolSprayer: AutoAwesomeOutlinedIcon,
  symbolScruncher: OpenWithOutlinedIcon,
  symbolSizer: OpenWithOutlinedIcon,
  symbolSpinner: RotateRightOutlinedIcon,
  symbolStainer: FormatColorFillOutlinedIcon,
  symbolScreener: OpacityOutlinedIcon,
  defineSymbol: AutoAwesomeOutlinedIcon,
  knife: CallSplitOutlinedIcon,
  measure: SquareFootOutlinedIcon,
  dimension: SquareFootOutlinedIcon,
  flipVertical: SwapVertOutlinedIcon,
  bringToFront: FlipToFrontOutlinedIcon,
  sendToBack: FlipToBackOutlinedIcon,
  pencil: GestureOutlinedIcon,
  smooth: GestureOutlinedIcon,
  eraser: AutoFixOffOutlinedIcon,
  scissors: ContentCutOutlinedIcon,
  paintbrush: BrushOutlinedIcon,
  pen: TimelineOutlinedIcon,
  addAnchor: AddCircleOutlineOutlinedIcon,
  deleteAnchor: RemoveCircleOutlineOutlinedIcon,
  rotate: RotateRightOutlinedIcon,
  scale: OpenWithOutlinedIcon,
  reflect: FlipOutlinedIcon,
  freeTransform: TransformOutlinedIcon,
  shapeBuilder: JoinFullOutlinedIcon,
  shapeBuilderMinus: JoinFullOutlinedIcon,
  shapeBuilderIntersect: JoinFullOutlinedIcon,
  shapeBuilderExclude: JoinFullOutlinedIcon,
  shear: SquareFootOutlinedIcon,
  duplicate: ContentCopyOutlinedIcon,
  join: CallMergeOutlinedIcon,
  offsetPath: CropFreeOutlinedIcon,
  outlineStroke: BorderColorOutlinedIcon,
  simplifyPath: GestureOutlinedIcon,
  averageAnchors: FilterCenterFocusOutlinedIcon,
  createOutlines: TextFieldsOutlinedIcon,
  align: AlignHorizontalLeftOutlinedIcon,
  alignLeft: AlignHorizontalLeftOutlinedIcon,
  alignHCenter: AlignHorizontalCenterOutlinedIcon,
  alignRight: AlignHorizontalRightOutlinedIcon,
  alignTop: AlignVerticalTopOutlinedIcon,
  alignVCenter: AlignVerticalCenterOutlinedIcon,
  alignBottom: AlignVerticalBottomOutlinedIcon,
  distributeH: SwapHorizOutlinedIcon,
  distributeV: SwapVertOutlinedIcon,
  type: TitleOutlinedIcon,
  areaType: TitleOutlinedIcon,
  verticalAreaType: TitleOutlinedIcon,
  typeOnPath: TitleOutlinedIcon,
  verticalTypeOnPath: TitleOutlinedIcon,
  verticalType: TitleOutlinedIcon,
  touchType: TextFieldsOutlinedIcon,
  characterPanel: TextFieldsOutlinedIcon,
  paragraphPanel: FormatAlignLeftOutlinedIcon,
  zoom: ZoomInOutlinedIcon,
  hand: PanToolOutlinedIcon,
  artboard: DashboardOutlinedIcon,
  eyedropper: ColorizeOutlinedIcon,
  gradient: GradientOutlinedIcon,
  createGradientMesh: GradientOutlinedIcon,
  livePaintBucket: FormatColorFillOutlinedIcon,
  livePaintSelection: HighlightAltOutlinedIcon,
};

const LONG_PRESS_MS = 320;
const BTN = 32;
const PITCH = 34;
const WIDTH = 44;

function ToolIcon({ id, size = 18 }) {
  const Comp = ICON_BY_ID[id] || NearMeOutlinedIcon;
  return <Comp sx={{ fontSize: size }} />;
}

/**
 * Barra Tools izquierda (VectorCraft Basic).
 * Flyout: click derecho, long-press, o click en el triángulo.
 * Color / Gradient / Fill-Stroke → dock derecho.
 */
export default function MoodboardVcToolbar({
  activeId = "selection",
  onSelectTool,
}) {
  const [slotShown, setSlotShown] = useState(() => {
    const m = {};
    VC_BASIC_TOOLBAR.forEach((cat) => {
      cat.slots.forEach((slot) => {
        if (slot[0]) m[slot[0].id] = slot[0].id;
      });
    });
    return m;
  });
  const [flyout, setFlyout] = useState(null); // { key, tools, left, top }
  const pressRef = useRef(null);
  const rootRef = useRef(null);
  const flyoutOpenedRef = useRef(false);

  useEffect(() => {
    VC_BASIC_TOOLBAR.forEach((cat) => {
      cat.slots.forEach((slot) => {
        const hit = slot.find((t) => t.id === activeId);
        if (hit && slot[0]) {
          setSlotShown((prev) =>
            prev[slot[0].id] === hit.id
              ? prev
              : { ...prev, [slot[0].id]: hit.id },
          );
        }
      });
    });
  }, [activeId]);

  const openFlyout = (slotKey, tools, anchorEl) => {
    if (!tools || tools.length < 2) return;
    const btn = anchorEl?.getBoundingClientRect?.();
    if (!btn) return;
    flyoutOpenedRef.current = true;
    setFlyout({
      key: slotKey,
      tools,
      left: btn.right + 6,
      top: Math.min(btn.top, window.innerHeight - 280),
    });
  };

  const closeFlyout = () => {
    setFlyout(null);
    flyoutOpenedRef.current = false;
  };

  // Cerrar flyout al click fuera (portal en body)
  useEffect(() => {
    if (!flyout) return undefined;
    const onDown = (e) => {
      const t = e.target;
      if (t?.closest?.("[data-vc-toolbar='1']")) return;
      if (t?.closest?.("[data-vc-flyout='1']")) return;
      setFlyout(null);
      flyoutOpenedRef.current = false;
    };
    const onKey = (e) => {
      if (e.key === "Escape") {
        setFlyout(null);
        flyoutOpenedRef.current = false;
      }
    };
    document.addEventListener("pointerdown", onDown, true);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("pointerdown", onDown, true);
      document.removeEventListener("keydown", onKey);
    };
  }, [flyout]);

  const pick = (tool) => {
    closeFlyout();
    if (!tool?.ready) return;
    VC_BASIC_TOOLBAR.forEach((cat) => {
      cat.slots.forEach((slot) => {
        if (slot.some((t) => t.id === tool.id) && slot[0]) {
          setSlotShown((prev) => ({ ...prev, [slot[0].id]: tool.id }));
        }
      });
    });
    onSelectTool?.(tool);
  };

  const clearPress = () => {
    const p = pressRef.current;
    if (p?.timer) window.clearTimeout(p.timer);
    pressRef.current = null;
  };

  const onBtnPointerDown = (e, slotKey, tools, shown) => {
    if (e.button === 2) {
      e.preventDefault();
      openFlyout(slotKey, tools, e.currentTarget);
      return;
    }
    if (e.button !== 0) return;
    flyoutOpenedRef.current = false;
    const el = e.currentTarget;
    try {
      el.setPointerCapture?.(e.pointerId);
    } catch {
      /* ignore */
    }
    const timer = window.setTimeout(() => {
      openFlyout(slotKey, tools, el);
      if (pressRef.current) pressRef.current.opened = true;
    }, LONG_PRESS_MS);
    pressRef.current = {
      timer,
      tool: shown,
      opened: false,
      pointerId: e.pointerId,
      el,
    };
  };

  const onBtnPointerUp = (e) => {
    const p = pressRef.current;
    if (!p) return;
    window.clearTimeout(p.timer);
    pressRef.current = null;
    try {
      p.el?.releasePointerCapture?.(e.pointerId);
    } catch {
      /* ignore */
    }
    // Si el long-press ya abrió el flyout, no seleccionar
    if (p.opened || flyoutOpenedRef.current) return;
    if (e.button === 0) pick(p.tool);
  };

  const onBtnPointerCancel = () => {
    clearPress();
  };

  return (
    <Box
      ref={rootRef}
      data-vc-toolbar="1"
      onContextMenu={(e) => e.preventDefault()}
      sx={{
        position: "relative",
        width: WIDTH,
        flexShrink: 0,
        alignSelf: "stretch",
        bgcolor: VC.panel,
        borderRight: `1px solid ${VC.panelBorder}`,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        py: 0,
        gap: 0,
        overflow: "hidden",
        userSelect: "none",
        zIndex: 5,
      }}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          width: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          py: 0.75,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {VC_BASIC_TOOLBAR.map((cat) => (
          <Box key={cat.category} sx={{ width: "100%", mb: 0.5 }}>
            <Typography
              sx={{
                fontSize: "0.52rem",
                fontWeight: 800,
                letterSpacing: 0.06,
                color: VC.textDim,
                textTransform: "uppercase",
                textAlign: "center",
                px: 0.25,
                mb: 0.25,
                lineHeight: 1.1,
              }}
            >
              {cat.category}
            </Typography>
            {cat.slots.map((slot) => {
              const slotKey = slot[0].id;
              const shownId = slotShown[slotKey] || slot[0].id;
              const shown = slot.find((t) => t.id === shownId) || slot[0];
              const active = activeId === shown.id;
              const hasFlyout = slot.length > 1;
              const tip = shown.ready
                ? `${shown.label}${shown.shortcut ? ` (${shown.shortcut})` : ""}${hasFlyout ? " · mantén / clic derecho" : ""}`
                : `${shown.label} (próximamente)`;
              return (
                <Box
                  key={slotKey}
                  component="button"
                  type="button"
                  title={tip}
                  disabled={!shown.ready && !hasFlyout}
                  onPointerDown={(e) =>
                    onBtnPointerDown(e, slotKey, slot, shown)
                  }
                  onPointerUp={onBtnPointerUp}
                  onPointerCancel={onBtnPointerCancel}
                  sx={{
                    position: "relative",
                    display: "grid",
                    placeItems: "center",
                    width: BTN,
                    height: BTN,
                    mx: "auto",
                    my: `${(PITCH - BTN) / 2}px`,
                    p: 0,
                    border: "none",
                    borderRadius: 1,
                    bgcolor: active ? VC.activeBg : "transparent",
                    color: !shown.ready
                      ? VC.iconDim
                      : active
                        ? VC.accent
                        : VC.icon,
                    cursor:
                      shown.ready || hasFlyout ? "pointer" : "not-allowed",
                    opacity: shown.ready || hasFlyout ? 1 : 0.45,
                    "&:hover":
                      shown.ready || hasFlyout
                        ? { bgcolor: active ? VC.activeBg : VC.hover }
                        : undefined,
                  }}
                >
                  <ToolIcon id={shown.id} />
                  {hasFlyout ? (
                    <Box
                      component="span"
                      onPointerDown={(e) => {
                        // Clic en el triángulo → abre flyout sin esperar long-press
                        e.preventDefault();
                        e.stopPropagation();
                        openFlyout(
                          slotKey,
                          slot,
                          e.currentTarget.parentElement,
                        );
                      }}
                      sx={{
                        position: "absolute",
                        right: 1,
                        bottom: 1,
                        width: 10,
                        height: 10,
                        display: "grid",
                        placeItems: "end",
                        cursor: "pointer",
                      }}
                    >
                      <Box
                        sx={{
                          width: 0,
                          height: 0,
                          borderStyle: "solid",
                          borderWidth: "0 0 6px 6px",
                          borderColor: `transparent transparent ${
                            active ? VC.accent : VC.iconDim
                          } transparent`,
                        }}
                      />
                    </Box>
                  ) : null}
                </Box>
              );
            })}
            <Box
              sx={{
                height: 1,
                mx: 1,
                my: 0.5,
                bgcolor: alpha("#fff", 0.06),
              }}
            />
          </Box>
        ))}
      </Box>

      {flyout &&
        createPortal(
          <Box
            data-vc-flyout="1"
            onPointerDown={(e) => e.stopPropagation()}
            sx={{
              position: "fixed",
              left: flyout.left,
              top: flyout.top,
              zIndex: 1400,
              bgcolor: VC.flyout,
              border: `1px solid ${VC.panelBorder}`,
              borderRadius: 1.5,
              boxShadow: "0 8px 28px rgba(0,0,0,0.45)",
              py: 0.5,
              minWidth: 176,
              maxHeight: "70vh",
              overflowY: "auto",
            }}
          >
            {flyout.tools.map((tool) => {
              const on = activeId === tool.id;
              return (
                <Box
                  key={tool.id}
                  component="button"
                  type="button"
                  disabled={!tool.ready}
                  onClick={() => pick(tool)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    width: "100%",
                    px: 1.25,
                    py: 0.65,
                    border: "none",
                    bgcolor: on ? VC.activeBg : "transparent",
                    color: !tool.ready ? VC.iconDim : on ? VC.accent : VC.text,
                    cursor: tool.ready ? "pointer" : "not-allowed",
                    textAlign: "left",
                    "&:hover": tool.ready
                      ? { bgcolor: on ? VC.activeBg : VC.hover }
                      : undefined,
                  }}
                >
                  <ToolIcon id={tool.id} size={16} />
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                        fontWeight: on ? 800 : 600,
                        lineHeight: 1.2,
                      }}
                    >
                      {tool.label}
                    </Typography>
                    {tool.shortcut ? (
                      <Typography
                        sx={{
                          fontSize: "0.62rem",
                          color: VC.textDim,
                          lineHeight: 1.2,
                        }}
                      >
                        {tool.shortcut}
                      </Typography>
                    ) : null}
                  </Box>
                  {!tool.ready ? (
                    <Typography sx={{ fontSize: "0.58rem", color: VC.iconDim }}>
                      soon
                    </Typography>
                  ) : null}
                </Box>
              );
            })}
          </Box>,
          document.body,
        )}
    </Box>
  );
}
